<template>
  <t-modal
    :name="id"
    :variant="`lg`"
    :hideCloseButton="true"
    :disableBodyScroll="true"
    :escToClose="false"
    :clickToClose="false"
    ref="popup"
  >
    <div class="h-96 pt-7">
      <section class="px-4 text-2xl font-extrabold text-center">
        {{ title }}
      </section>
      <section class="px-4 py-5 mb-10">
        <TRichSelect
          v-model="fleet"
          :options="fleets"
          :close-on-select="true"
          :placeholder="'Select a Fleet'"
        />
      </section>
    </div>
    <section
      class="flex items-center justify-end px-4 py-4 mt-6 space-x-5 bg-gray-50"
    >
      <AppButton
        :variant="cancelButtonVariant"
        :class="`w-1/2`"
        @click="executeAction('cancel')"
      >
        {{ cancelButtonText }}
      </AppButton>

      <AppButton
        :variant="confirmButtonVariant"
        :class="`w-1/2`"
        @click="executeAction"
      >
        {{ confirmButtonText }}
      </AppButton>
    </section>
  </t-modal>
</template>

<script>
import { useEndpoints } from '@/composables'

export default {
  name: 'FleetChangeModal',
  components: {},

  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: [String, Number],
      required: false,
      default: 'Please select a fleet',
    },
    subtitle: {
      type: [String, Number],
      required: false,
    },
    cancelButtonText: {
      type: [String, Number],
      required: false,
      default: 'Cancel',
    },
    cancelButtonVariant: {
      type: String,
      required: false,
      default: 'secondary',
    },
    confirmButtonText: {
      type: [String, Number],
      required: false,
      default: 'Continue',
    },
    confirmButtonVariant: {
      type: String,
      required: false,
      default: 'primary',
    },
  },

  data: () => ({
    fleets: [],
    fleet: null,
  }),
  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      this.fleets = await this.$http
        .get(useEndpoints.dropdown.fleets())
        .then((res) =>
          res.data.data.map((fleet) => {
            return {
              text: fleet.name,
              value: fleet.id,
            }
          })
        )
        .catch((err) => console.log('fleetsErr = ', err.response))
    },
    executeAction(action = null) {
      if (action === 'cancel') {
        this.fleet = null
        this.$refs.popup.hide()
        this.$store.dispatch('fsTable/fetchData')
      } else {
        if (!this.fleet) {
          this.$notify(
            {
              group: 'generic',
              type: 'default',
              title: 'Info',
              text: 'Please select a fleet',
            },
            3000
          )
          return
        }
        this.fleetData = this.fleets.find((f) => f.value === this.fleet)
        this.$emit('confirm', {
          id: this.fleetData.value,
          name: this.fleetData.text,
        })
        this.$refs.popup.hide()
        this.fleet = null
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
